import { render, staticRenderFns } from "./CopyStakeWheelOfFortuneCampaignDialogStreamerTab.vue?vue&type=template&id=accb1a26&scoped=true&lang=pug"
import script from "./CopyStakeWheelOfFortuneCampaignDialogStreamerTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWheelOfFortuneCampaignDialogStreamerTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWheelOfFortuneCampaignDialogStreamerTab.vue?vue&type=style&index=0&id=accb1a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accb1a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
